module.exports = __webpack_public_path__ + "static/media/example-ces.58fb9fe8.csv";